import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const HeaderRlt2 = () => {
  return <header className="bg-white" data-id="element-18140" data-mp="1w0n677pb30ff">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-18141" data-mp="1vz29pcjfl7ex"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-18142" data-mp="20z6tpcjjsk9w">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-18143" data-mp="25rzwhuvghijc">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-18144" data-mp="2aqueiulln32e">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-18145" data-mp="2fnum59y3kdvm">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex justify-start mb-3" data-id="element-18146" data-mp="2op15rrw1m4t3">
          <div className="text-xs text-gray-400 font-sans" data-id="element-18147" data-mp="2onpyhi3e2ex8">Advertorial 2</div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-18148" data-mp="pfchqrm0goni">
          <div className="text-left" data-id="element-18149" data-mp="1vvkb7ypik7q6">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-18150" data-mp="1vx54ll03dkmg">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-18151" data-mp="2erk2t8ekx998">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-18152" data-mp="25rx6h10pitn1">
        <div className="max-w-4xl mx-auto" data-id="element-18153" data-mp="20un82vvcb7n2">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-18154" data-mp="20tvm8crjoo9z">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-18155" data-mp="pdx3tiah8pw3">
            PhD Investigates: "Deep" Red Light Therapy Drains Stubborn Fat—But
            Only If The Light Actually Reaches It
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-18156" data-mp="vsulal8i5qx7">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-18157" data-mp="hv635l5tkxvu">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell" className="w-full h-full object-cover" data-id="element-18158" data-mp="mwd9dfsbdp0e" />
            </div>
            <div className="flex-1" data-id="element-18159" data-mp="cyfn2xu0m2af">
              <div className="flex items-center" data-id="element-18160" data-mp="3vavlptpafqpt">
                <div className="font-medium text-gray-900 text-lg" data-id="element-18161" data-mp="3vc6p3setmwge">
                  By Dr. Sarah Mitchell, PhD
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-18162" data-mp="3lcfuzru6ajgu">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-18163" data-mp="3le90v4wyozns" />
                  <span className="text-xs ml-1 font-medium" data-id="element-18164" data-mp="3qa7mwluti5l1">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-18165" data-mp="36pzabnfltloa">
                Exercise Physiology, University of Texas
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-18166" data-mp="31sqnh9jigtgp">
                <div className="flex items-center mr-4" data-id="element-18167" data-mp="3goy8ud6no0xk">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-18168" data-mp="3boak5y5wfw6i" />
                  <span data-id="element-18169" data-mp="3bqmwnvsw1ec6">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-18170" data-mp="3pn0gvcot3tuc">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-18171" data-mp="3kp8dnmipolau" />
                  <span data-id="element-18172" data-mp="3kop875a8zpdp">47,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-18173" data-mp="37z1k6285c9m">
            I tested 8 red light therapy devices claiming to work for fat loss
            on 14 volunteers for 12 weeks. Only ONE consistently burned fat as
            in the clinical trials. It was called the "Deep" Red Light Therapy
            Wrap. I needed to know why.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-18174" data-mp="26pnfujx6qj3e">
            <div className="mb-1 flex items-center" data-id="element-18175" data-mp="2bgm01ulao1bx">
              <span className="font-medium mr-2" data-id="element-18176" data-mp="2bh5gf6vaqhnu">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-18177" data-mp="1irohrrh324j6">
              <span className="font-medium mr-2" data-id="element-18178" data-mp="1it9arcnr1fex">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-18179" data-mp="347dt4j72c9v1">
        <div className="max-w-4xl mx-auto" data-id="element-18180" data-mp="3851ofnco44ng">
          <div className="sm:flex items-center" data-id="element-18181" data-mp="wj18rhusz2rx">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-18182" data-mp="wirhlqy0upkn">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell in research lab" className="w-full rounded-lg shadow-md" data-id="element-18183" data-mp="sh5xpln2lb0y" />
            </div>
            <div className="sm:w-2/3" data-id="element-18184" data-mp="isnwj3avp1ws">
              <p className="text-sm text-gray-700 mb-2" data-id="element-18185" data-mp="ips1pnubutck">
                <span className="font-bold" data-id="element-18186" data-mp="dt1k2w2vjpp1">Dr. Sarah Mitchell, PhD</span> has
                spent 25 years in exercise physiology research and clinical
                practice. With a doctorate from the University of Texas, she has
                published extensively on metabolic adaptation and body
                composition.
              </p>
              <p className="text-sm text-gray-700" data-id="element-18187" data-mp="3w0r1suul97ej">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderRlt2;